import { toast } from "react-toastify";
import apiClient from "../../../apiClient/apiClient";
import {
  SUBSCRIPTION_REQUEST,
  SUBSCRIPTION_SUCCESS,
  SUBSCRIPTION_FAILURE,
} from "../constant/SubscriptionConstants";

export const subscription = (values) => async (dispatch) => {
  if (!values.full_name || !values.email) {
    toast.error("Please fill in all fields");
    dispatch({ 
      type: SUBSCRIPTION_FAILURE, 
      payload: "Missing required fields" 
    });
    return false;
  }
  
  dispatch({ type: SUBSCRIPTION_REQUEST });
  
  try {
    // Make a direct POST request - let the server handle duplicate checking
    const response = await apiClient.post("subscription/", values);
    
    dispatch({
      type: SUBSCRIPTION_SUCCESS,
      payload: response.data,
    });
    
    toast.success('Newsletter subscribed successfully');
    return true;
    
  } catch (error) {
    console.error("Subscription error:", error);
    
    // Check for specific error cases from the server
    if (error.response?.data?.email?.[0]?.includes("already exists")) {
      toast.info("You are already subscribed to the newsletter!");
      dispatch({
        type: SUBSCRIPTION_FAILURE,
        payload: "Already subscribed",
      });
    } else {
      toast.error("Subscription failed. Please try again.");
      dispatch({
        type: SUBSCRIPTION_FAILURE,
        payload: error.response?.data || error.message,
      });
    }
    
    return false;
  }
};
